module.exports = __webpack_public_path__ + "static/img/wg_card_bg.6d0baa68.png";